import AtomicApps from "../../../../src/courses/partials/atomic/apps.mdx";
import * as React from 'react';
export default {
  AtomicApps,
  React
};